import { Signatory } from './signatory';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { TableSignUserBase } from './table-sign-user-base';
import { ObjectUtil } from '../ObjectUtil';

export class TableSignUser extends TableSignUserBase {

  static propCheck = 'checked';
  static propOrder = 'order';

  public signUsers = new Subject<Array<Signatory>>();
  private elements: Array<Signatory>;
  private elementSelecteds: Array<Signatory>;

  constructor(public translate: TranslateService) {
    super(translate);
    this.elements = [];
    this.elementSelecteds = [];
    this.createInitObject().pipe(take(1)).subscribe(x => x.subscribe(() => this.OnInit()));
  }

  OnInit() {
  }

  updateElement(el: any, obj: {}) {
    const indexElement = this.elements.indexOf(el);
    Object.assign(this.elements[indexElement], obj);
    this.signUsers.next(this.elements);
  }

  updateElements(ev: any) {
    this.elements.forEach(el => Object.assign(el, ev));
    this.signUsers.next(this.elements);
  }

  updateByElementId(ev: any) {
    this.elements.some(el => {
      if ((el.id) && (el.id === ev.id)) {
        Object.assign(el, ev);
      }
    });
  }

  getElementOptions(element): any {
    return { span: '', value: element[TableSignUser.propCheck] };
  }

  getElementSelected(): Array<Signatory> {
    return this.elementSelecteds;
  }

  getList(filter) {
    this.signUsers.next(this.elements.filter(item =>
      Object.keys(item).some(
        k =>
          item[k] != null &&
          item[k]
            .toString()
            .toLowerCase()
            .includes(filter.toLowerCase())
      )
    ));
  }

  removeEl(user: Signatory) {
    const index = this.elements.indexOf(user);
    this.elements.splice(index, 1);
    this.signUsers.next(this.elements);
  }

  addEl(user: Signatory) {
    this.elements.push(user);
    this.signUsers.next(this.elements);
  }

  addElSelected(user: Signatory) {
    this.elements.push(user);
    this.signUsers.next(this.elements);
  }

  addList(users: Array<Signatory>) {
    this.elements = Object.assign([], users);
    this.signUsers.next(this.elements);
  }

  addListSelecteds(users: Array<Signatory>) {
    this.elementSelecteds = Object.assign([], users);
    this.signUsers.next(this.elementSelecteds);
  }

  mergeList(users: Array<Signatory>) {
    const maxExistentOrder = this.maxSignatoryOrder();
    let counter = 0;
    users.forEach(user => {
      const isNewUser = this.mergeById(user, maxExistentOrder);
      if (isNewUser) {
        counter++;
      }
    });
    this.signUsers.next(this.elements);
    return counter;
  }

  anyCheckedElement(): boolean {
    return this.elements.anyChecked(TableSignUser.propCheck);
  }

  countCheckedElements(): number {
    return this.elementSelecteds.filter(el => el[TableSignUser.propCheck]).length;
  }

  deselectAll() {
    this.elements.forEach(el => el[TableSignUser.propCheck] = false);
    this.signUsers.next(this.elements);
    this.elementSelecteds = [];
  }

  selectAll() {
    this.elementSelecteds = [];
    this.elements.forEach(el => el[TableSignUser.propCheck] = true);
    this.signUsers.next(this.elements);
    this.elementSelecteds = this.elements.filter(el => el[TableSignUser.propCheck]);
  }

  contains(prop, value) {
    return this.elements.some(el => el[prop] == value);
  }

  changeElementPropertyValue(el, propName, propNewValue) {
    const indexElement = this.elements.indexOf(el);
    this.elements[indexElement][propName] = propNewValue;
    this.signUsers.next(this.elements);
    this.signUsers.next(this.elementSelecteds);
  }

  maxSignatoryOrder(): number {
    return Math.max(...this.elements.map(el => el.order), 0);
  }

  private mergeById(user: Signatory, maxOrder: number) {
    let findUser;
    this.elements.some(el => {
      if ((el.id) && (el.id === user.id)) {
        findUser = Object.assign(el, user);
        return true;
      }
    });
    if ((!(findUser)) || ObjectUtil.isEmpty(findUser)) {
      user.order = maxOrder + 1;
      this.elements.push(user);
      return true;
    }
    return false;
  }

}
